import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IIconProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IIconProps>>
): IComponentSchema<IIconProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Icon',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Icon,
    'x-component-props': {
      visible: true,
      name: 'FireOutlined',
    },
    'x-component-props-config': {},
  };
};
